import { render } from "./ModalCardDetails.vue?vue&type=template&id=5b252ada"
import script from "./ModalCardDetails.vue?vue&type=script&lang=js"
export * from "./ModalCardDetails.vue?vue&type=script&lang=js"

import "./ModalCardDetails.vue?vue&type=style&index=0&id=5b252ada&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__